import { useQueryWithUserId } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';

interface IFetchPodLocationListQueryPayload {
  enabled: boolean;
  gcTime?: number;
  inventoryId: string;
  staleTime?: number;
}

/**
 * This key is used to track POD location list queries in the cache.
 * It is used to identify the query in the cache and to refetch it when needed.
 */
export const PODS_LOCATION_LIST_QUERY_KEY = 'PODS_LOCATION_LIST_QUERY_KEY';

/**
 * This hook fetches the list of POD locations from the backend.
 */
export const useFetchPodLocationListQuery = ({
  gcTime,
  enabled,
  inventoryId,
  staleTime,
}: IFetchPodLocationListQueryPayload) => {
  const { data, error, isError, isFetching, isPending, refetch } =
    useQueryWithUserId({
      enabled,
      gcTime,
      networkMode: 'always',
      queryFn: () => INV_MGMT_SERVICE_API.getPodLocations({ inventoryId }),
      queryKey: [PODS_LOCATION_LIST_QUERY_KEY, inventoryId],
      retry: false,
      staleTime,
    });

  return {
    data,
    error,
    isError,
    isFetching,
    isPending,
    refetch,
  };
};
